import { JSX, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router";
import { ROUTES } from "../constants/routes.constant";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { isArchivedEvent } from "../utils/eventMenu";

const AuthChecker = ({
  permissions,
  children,
}: {
  permissions: string[];
  children: JSX.Element;
}) => {
  const { pathname } = useLocation();
  const event = useSelector((state: RootState) => state.event);
  const [hasPermission, setHasPermission] = useState(true);

  useLayoutEffect(() => {
    const foundEntry = Object.entries(ROUTES).find(
      ([, value]) => value.path.split("/")?.[1] === pathname.split("/")?.[1]
    );

    if (foundEntry) {
      const [, route] = foundEntry;
      if (route && "access_name" in route) {
        if (
          route.access_name === "refunds" &&
          isArchivedEvent(event?.status)
        ) {
          setHasPermission(true);
        } else {
          setHasPermission(permissions?.includes(route.access_name!));
        }
      } else {
        setHasPermission(true);
      }
    } else {
      setHasPermission(true);
    }
  }, [pathname, permissions, event?.status]);

  return <>{hasPermission ? children : <></>}</>;
};

export default AuthChecker;

export const AuthCheckerHide = ({
  children,
  access_name,
}: {
  children: JSX.Element;
  access_name: string;
}) => {
  const event = useSelector((state: RootState) => state.event);

  return event?.permissions?.event_access?.permissions?.includes(
    access_name
  ) ? (
    children
  ) : (
    <></>
  );
};
